import { usePublicConfig } from '@/hooks/queries/usePublicConfig';
import { useSiteName } from '@/hooks/useSiteName';
import { cn } from '@/lib/utils';

interface SiteLogoProps {
  /** Optional wordmark override when no logo URL is configured. */
  fallback?: string;
  className?: string;
  imageClassName?: string;
  /** Optional accessible text override for the configured logo image. */
  alt?: string;
}

/** Render the configured logo, falling back to the configured site name. */
export function SiteLogo({
  fallback,
  className,
  imageClassName,
  alt,
}: SiteLogoProps) {
  const siteName = useSiteName();
  const { data } = usePublicConfig('site.logo_url');
  const logoUrl = data?.config_value?.trim();
  const wordmark = fallback?.trim() || siteName;

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={alt ?? siteName}
        className={cn('h-8 w-auto object-contain', imageClassName, className)}
      />
    );
  }

  return <span className={className}>{wordmark}</span>;
}
